import { apiClient } from './api-client';
import { UserRole } from '@/types/index';

export interface AdminUser {
  id: string;
  email: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  role: UserRole;
  planExpiresAt?: string | null;
  createdAt: string;
  propertyCount: number;
}

export interface AdminStats {
  totalUsers: number;
  totalProperties: number;
  byRole: {
    FREEMIUM: number;
    PREMIUM: number;
    PRO: number;
    ADMIN: number;
  };
}

export interface AppSettings {
  id: string;
  trialDays: number;
}

export const adminService = {
  listUsers: (): Promise<AdminUser[]> =>
    apiClient.get('/admin/users'),

  updateUserRole: (id: string, role: UserRole): Promise<{ id: string; email: string; name?: string; role: UserRole }> =>
    apiClient.patch(`/admin/users/${id}/role`, { role }),

  getStats: (): Promise<AdminStats> =>
    apiClient.get('/admin/stats'),

  getSettings: (): Promise<AppSettings> =>
    apiClient.get('/admin/settings'),

  updateSettings: (trialDays: number): Promise<AppSettings> =>
    apiClient.patch('/admin/settings', { trialDays }),

  refreshCommunes: (): Promise<{ created: number; updated: number; total: number }> =>
    apiClient.post('/admin/refresh-communes', {}),

  checkOffMarket: (): Promise<{ checked: number; markedOffMarket: number; scraperUnreachable: boolean }> =>
    apiClient.post('/admin/check-offmarket', {}),
};
